module.exports = __webpack_public_path__ + "img/banner-img.5e541280.png";